(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function initialiseTabs() {
const isMobile = window.matchMedia("(max-width: 767px)").matches;

const plusIcon = document.getElementById('plus-icon').innerHTML;
const minusIcon = document.getElementById('minus-icon').innerHTML;

document.querySelectorAll('.footer-block details').forEach((details) => {
const summary = details.querySelector('summary');
const iconContainer = summary.querySelector('.icon');

summary.setAttribute('aria-expanded', details.hasAttribute('open'));

iconContainer.innerHTML = details.hasAttribute('open') ? minusIcon : plusIcon;

if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
summary.setAttribute('aria-controls', summary.nextElementSibling.id);
}

summary.addEventListener('click', (event) => {
const clickedSummary = event.currentTarget;
const parentDetails = clickedSummary.closest('details');
const isOpen = parentDetails.hasAttribute('open');

clickedSummary.setAttribute('aria-expanded', !isOpen);

iconContainer.innerHTML = isOpen ? plusIcon : minusIcon;
});
});
}

initialiseTabs();
window.addEventListener('resize', initialiseTabs);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size' || this.getAttribute('data-sticky-type') === 'always-float';;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

//Adds class to header when menu item is open
  document.addEventListener("DOMContentLoaded", function() {
      const headerWrapper = document.querySelector('.header-wrapper');
      const dropdowns = document.querySelectorAll('details.mega-menu');

      if (dropdowns.length > 0 && headerWrapper) {
          dropdowns.forEach(dropdown => {
              dropdown.addEventListener('toggle', function() {
                  if (dropdown.open) {
                      headerWrapper.classList.add('menu-open-active');
                  } else {
                      const anyOpen = Array.from(dropdowns).some(d => d.open);
                      if (!anyOpen) {
                          headerWrapper.classList.remove('menu-open-active');
                      }
                  }
              });
          });
      }
  });


    
  } catch(e) { console.error(e); }
})();
})();
